<template>
  <van-empty description="暂无数据" class="mt50" v-if="list.length==0" />
  <div class="scroll" style="height:calc(100vh - 90px)" ref="wrapper" @scroll.passive="isScrollBottom">
    <div class="paperlist" v-for="item,index in list" :key="index">
      <div @click="$router.push({path:'/paper/detail',query:{id:item.id,cate_id:item.cate_id}})" class="myflex">
        <img :src="item.thumb" class="thumb" :onerror="imgError">
        <div class="textwidth">
          <p class="paperlist-tle">{{item.name}}<span>
              <!-- <router-link :to="{path:'/paper/detail',query:{id:item.id,cate_id:item.cate_id}}">查看详情</router-link> -->
            </span></p>
          <p class="paperlist-id">{{item.no}}</p>
          <p class="paperlist-intro">简介：<span>{{item.description}}</span></p>
          <p class="paperlist-info"><span>发布人:{{item.publish_name}}</span><span>{{item.add_time}}</span></p>
        </div>
      </div>
      <!-- <div class="paperlist-btn">
        <p @click="handleFix(item.id)">申请下架</p>
      </div> -->
      <div class="flex size12 opacity8 right">
          <p>综合评分:{{item.score_star}}</p>
          <p class="ml20">文化价值:{{item.invest_amount}}</p>
          <p class="ml20">浏览量:{{item.browse}}</p>
        </div>
    </div>
  </div>
  <Dialog :title="title" v-model:show="show" :fn="fn">
    <p class="paper-tip">提示请确认是否申请下架您的论文</p>
  </Dialog>
</template>
<script>
export default {
  data () {
    return {
      list: []
    }
  },
  methods: {
    getList (page) {
      this.page = page || this.page;
      let list = this.list;
      if (this.page > 1) {
        if (this.page > this.count) {
          return this.page = this.count;
        }
      } else {
        list = [];
      }
      this.ajax.post("users/getpaperlist", { page: this.page }).then(({ data, count }) => {
        this.list = list.concat(data);
        this.count = count;
        console.log(this.list);
      }).finally(() => {
        this.isLoading = false;
      })
    },
    isScrollBottom () {
      // 是否滚动到了底部
      this.box = this.$refs.wrapper
      var clientHeight = this.box.clientHeight
      var scrollTop = this.box.scrollTop
      var scrollHeight = this.box.scrollHeight
      if (scrollTop + clientHeight == scrollHeight) {
        this.getList(this.page + 1);
      }
    },
    next () {
      history.forward()
    },
  },
  created () {
    this.getList();
  }
}
</script>
<script setup>
import Dialog from "@/components/Dialog.vue";
import { ref } from "vue";
import ajax from "@/utils/request.js";
import { showSuccessToast } from 'vant';

const title = ref("申请论文");

const show = ref(false);
// const handleFix = (id) => {
//   title.value = "提示";
//   show.value = true;
//   currentid.value = id
// }

const currentid = ref();
const fn = () => {
  show.value = false
  ajax.post("users/paperdown", { id: currentid.value }).then(res => {
    if (res.errcode === 1) {
      showSuccessToast('申请成功');
      show.value = false
    }
  })
};
</script>
<style scoped>
    .paperlist {
        padding: 4vw;
        background-color: #fff;
        margin-bottom: 2.6667vw;
    }
    .paperlist-tle {
        font-size: 16px;
        color: #333333;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .paperlist-tle span {
        font-size: 14px;
        color: #3F7C93;
        text-align: right;
    }
    .paperlist-id {
        font-size: 12px;
        color: #666666;
        margin-top: 2.1333vw;
        margin-bottom: 4.2667vw;
    }
    .paperlist-intro {
        font-size: 14px;
        color: #333333;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .paperlist-btn {
        display: flex;
        flex-direction: row-reverse;
    }
    .paperlist-btn p {
        width: 5.5rem;
        height: 8.5333vw;
        line-height: 8.5333vw;
        text-align: center;
        border: 1px solid #3F7C93;
        border-radius: 5.3333vw;
        color: #3F7C93;
    }
    .paperlist-btn p:first-child {
        margin-left: 2.1333vw;
    }
    .paperlist-info {
        font-size: 12px;
        color: #666666;
        display: flex;
        justify-content: space-between;
        margin-top: 2.1333vw;
        margin-bottom: 4vw;
    }
    .paper-tip {
        text-align: center;
        font-size: 14px;
        color: #333333;
        margin-top: 32px;
        margin-bottom: 45px;
    }
    .myflex {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.textwidth { 
  width: calc(100% - 115px - 5px);
}
.thumb {
  display: block;
  width: 115px;
  height: 115px;
  margin-right: 5px;
  object-fit: contain;
}
</style>